import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/noto-serif-sc/400.css";
import "@fontsource/noto-serif-sc/500.css";
import "@fontsource/noto-sans-sc/400.css";
import "@fontsource/noto-sans-sc/500.css";
import "@fontsource/bodoni-moda/500.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import App from "./App";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

async function render() {
  if (import.meta.env.DEV && window.location.pathname.startsWith("/__capture/")) {
    const { DesktopCaptureApp } = await import("./dev/DesktopCaptureApp");
    root.render(<StrictMode><DesktopCaptureApp /></StrictMode>);
    return;
  }
  if (import.meta.env.DEV && window.location.pathname.startsWith("/__visual/")) {
    const { VisualRegressionApp } = await import("./dev/VisualRegressionApp");
    root.render(<StrictMode><VisualRegressionApp /></StrictMode>);
    return;
  }
  root.render(<StrictMode><App /></StrictMode>);
}

void render();
